/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActiveFeaturedShowsRequest,
    AddUserToLiveStreamCommentDenylist,
    CommentUpvoteItem,
    CommentUpvotersResponse,
    ConnectTwoWayStreamRequest,
    CreateLiveStreamRequest,
    CreateLiveStreamResponse,
    CreateTipRequest,
    CreateTwoWayStreamRequest,
    EditLiveStreamRequest,
    GenerateTokenRequest,
    GetLiveStreamNftsResponse,
    GetNftAvatarResponse,
    GetRecordingURLsResponse,
    IdResponse,
    JoinRequest,
    ModerateLiveStreamRequest,
    MostUpvotedCommentResponse,
    MostUpvotedCommentResponseWrapper,
    PatchLiveStreamRequest,
    PauseRequest,
    PreviewLiveStreamWrapEmailRequest,
    PreviewLiveStreamWrapEmailResponse,
    ReportLiveStreamRequest,
    ResumeLiveStreamRequest,
    SendCommentRequest,
    SendWrapUpEmailRequest,
    StartWatchRequest,
    SwitchShowEventRequest,
    SwitchUpcomingShowRequest,
    TokensResponse,
    UpdateTipRequest,
    WaveFollowersToWatchRequest,
    WavedToUserEnterRequest,
} from '../models';

export interface LiveStreamApiControllerActiveFeaturedShowsRequest {
    liveStreamId: string;
    activeFeaturedShowsRequest: ActiveFeaturedShowsRequest;
}

export interface LiveStreamApiControllerAddUserToLiveStreamCommentDenylistRequest {
    liveStreamId: string;
    userId: string;
    addUserToLiveStreamCommentDenylist: AddUserToLiveStreamCommentDenylist;
}

export interface LiveStreamApiControllerConnectTwoWayStreamRequest {
    liveStreamId: string;
    connectTwoWayStreamRequest: ConnectTwoWayStreamRequest;
}

export interface LiveStreamApiControllerCreateLiveStreamRequest {
    createLiveStreamRequest: CreateLiveStreamRequest;
}

export interface LiveStreamApiControllerCreateTipRequest {
    liveStreamId: string;
    createTipRequest: CreateTipRequest;
}

export interface LiveStreamApiControllerCreateTwoWayStreamRequest {
    liveStreamId: string;
    createTwoWayStreamRequest: CreateTwoWayStreamRequest;
}

export interface LiveStreamApiControllerDeleteCommentRequest {
    liveStreamId: string;
    commentId: string;
}

export interface LiveStreamApiControllerDisconnectWalletRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerEditLiveStreamRequest {
    liveStreamId: string;
    editLiveStreamRequest: EditLiveStreamRequest;
}

export interface LiveStreamApiControllerEndTwoWayStreamRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerFinishLiveStreamRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerGenerateTokensRequest {
    liveStreamId: string;
    generateTokenRequest: GenerateTokenRequest;
    gatedShowPassword?: string;
}

export interface LiveStreamApiControllerGetCommentUpvotersRequest {
    liveStreamId: string;
    commentId: string;
    limit: number;
}

export interface LiveStreamApiControllerGetCommentUpvotesRequest {
    liveStreamId: string;
    sinceMinutesAgo?: number;
}

export interface LiveStreamApiControllerGetGatedShowPasswordRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerGetMostUpvotedCommentRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerGetMostUpvotedCommentV2Request {
    liveStreamId: string;
}

export interface LiveStreamApiControllerGetNftAvatarRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerGetNftsRequest {
    liveStreamId: string;
    address: string;
    signature: string;
    expiredAt: string;
}

export interface LiveStreamApiControllerGetRecordingURLsRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerJoinRequest {
    liveStreamId: string;
    gatedShowPassword?: string;
    joinRequest?: JoinRequest;
}

export interface LiveStreamApiControllerModerateLiveStreamRequest {
    liveStreamId: string;
    moderateLiveStreamRequest: ModerateLiveStreamRequest;
}

export interface LiveStreamApiControllerPatchLiveStreamRequest {
    liveStreamId: string;
    patchLiveStreamRequest: PatchLiveStreamRequest;
}

export interface LiveStreamApiControllerPauseLiveStreamRequest {
    liveStreamId: string;
    pauseRequest?: PauseRequest;
}

export interface LiveStreamApiControllerPreviewWrapUpEmailRequest {
    liveStreamId: string;
    previewLiveStreamWrapEmailRequest: PreviewLiveStreamWrapEmailRequest;
}

export interface LiveStreamApiControllerRemoveTipRequest {
    liveStreamId: string;
    tipId: string;
}

export interface LiveStreamApiControllerRemoveUserFromLiveStreamCommentDenylistRequest {
    liveStreamId: string;
    userId: string;
}

export interface LiveStreamApiControllerReplayLiveStreamHeartBeatRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerReportLiveStreamRequest {
    liveStreamId: string;
    reportLiveStreamRequest: ReportLiveStreamRequest;
}

export interface LiveStreamApiControllerResumeLiveStreamRequest {
    liveStreamId: string;
    resumeLiveStreamRequest?: ResumeLiveStreamRequest;
}

export interface LiveStreamApiControllerSendCommentRequest {
    liveStreamId: string;
    commentId: string;
    sendCommentRequest: SendCommentRequest;
}

export interface LiveStreamApiControllerSendNotificationToWaitlistRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerSendWrapUpEmailRequest {
    liveStreamId: string;
    sendWrapUpEmailRequest: SendWrapUpEmailRequest;
}

export interface LiveStreamApiControllerStartLiveStreamRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerStartWatchingRequest {
    liveStreamId: string;
    startWatchRequest: StartWatchRequest;
}

export interface LiveStreamApiControllerStopWatchingRequest {
    liveStreamId: string;
}

export interface LiveStreamApiControllerSwitchShowEventRequest {
    liveStreamId: string;
    switchShowEventRequest: SwitchShowEventRequest;
}

export interface LiveStreamApiControllerSwitchUpcomingShowRequest {
    liveStreamId: string;
    switchUpcomingShowRequest: SwitchUpcomingShowRequest;
}

export interface LiveStreamApiControllerUpdateTipRequest {
    liveStreamId: string;
    tipId: string;
    updateTipRequest: UpdateTipRequest;
}

export interface LiveStreamApiControllerUpvoteCommentRequest {
    liveStreamId: string;
    commentId: string;
}

export interface LiveStreamApiControllerWaveFollowersToWatchRequest {
    liveStreamId: string;
    waveFollowersToWatchRequest: WaveFollowersToWatchRequest;
}

export interface LiveStreamApiControllerWavedToUserEnterRequest {
    liveStreamId: string;
    wavedToUserEnterRequest: WavedToUserEnterRequest;
}

/**
 * 
 */
export class LiveStreamApi extends runtime.BaseAPI {

    /**
     */
    async liveStreamApiControllerActiveFeaturedShowsRaw(requestParameters: LiveStreamApiControllerActiveFeaturedShowsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerActiveFeaturedShows.');
        }

        if (requestParameters.activeFeaturedShowsRequest === null || requestParameters.activeFeaturedShowsRequest === undefined) {
            throw new runtime.RequiredError('activeFeaturedShowsRequest','Required parameter requestParameters.activeFeaturedShowsRequest was null or undefined when calling liveStreamApiControllerActiveFeaturedShows.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/featuredShows:active`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.activeFeaturedShowsRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerActiveFeaturedShows(requestParameters: LiveStreamApiControllerActiveFeaturedShowsRequest): Promise<void> {
        await this.liveStreamApiControllerActiveFeaturedShowsRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerAddUserToLiveStreamCommentDenylistRaw(requestParameters: LiveStreamApiControllerAddUserToLiveStreamCommentDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling liveStreamApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        if (requestParameters.addUserToLiveStreamCommentDenylist === null || requestParameters.addUserToLiveStreamCommentDenylist === undefined) {
            throw new runtime.RequiredError('addUserToLiveStreamCommentDenylist','Required parameter requestParameters.addUserToLiveStreamCommentDenylist was null or undefined when calling liveStreamApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/blocked/{userId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserToLiveStreamCommentDenylist,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerAddUserToLiveStreamCommentDenylist(requestParameters: LiveStreamApiControllerAddUserToLiveStreamCommentDenylistRequest): Promise<void> {
        await this.liveStreamApiControllerAddUserToLiveStreamCommentDenylistRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerConnectTwoWayStreamRaw(requestParameters: LiveStreamApiControllerConnectTwoWayStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerConnectTwoWayStream.');
        }

        if (requestParameters.connectTwoWayStreamRequest === null || requestParameters.connectTwoWayStreamRequest === undefined) {
            throw new runtime.RequiredError('connectTwoWayStreamRequest','Required parameter requestParameters.connectTwoWayStreamRequest was null or undefined when calling liveStreamApiControllerConnectTwoWayStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:connect-two-way-stream`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.connectTwoWayStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerConnectTwoWayStream(requestParameters: LiveStreamApiControllerConnectTwoWayStreamRequest): Promise<void> {
        await this.liveStreamApiControllerConnectTwoWayStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerCreateLiveStreamRaw(requestParameters: LiveStreamApiControllerCreateLiveStreamRequest): Promise<runtime.ApiResponse<CreateLiveStreamResponse>> {
        if (requestParameters.createLiveStreamRequest === null || requestParameters.createLiveStreamRequest === undefined) {
            throw new runtime.RequiredError('createLiveStreamRequest','Required parameter requestParameters.createLiveStreamRequest was null or undefined when calling liveStreamApiControllerCreateLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createLiveStreamRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerCreateLiveStream(requestParameters: LiveStreamApiControllerCreateLiveStreamRequest): Promise<CreateLiveStreamResponse> {
        const response = await this.liveStreamApiControllerCreateLiveStreamRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerCreateTipRaw(requestParameters: LiveStreamApiControllerCreateTipRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerCreateTip.');
        }

        if (requestParameters.createTipRequest === null || requestParameters.createTipRequest === undefined) {
            throw new runtime.RequiredError('createTipRequest','Required parameter requestParameters.createTipRequest was null or undefined when calling liveStreamApiControllerCreateTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/tips`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTipRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerCreateTip(requestParameters: LiveStreamApiControllerCreateTipRequest): Promise<IdResponse> {
        const response = await this.liveStreamApiControllerCreateTipRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerCreateTwoWayStreamRaw(requestParameters: LiveStreamApiControllerCreateTwoWayStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerCreateTwoWayStream.');
        }

        if (requestParameters.createTwoWayStreamRequest === null || requestParameters.createTwoWayStreamRequest === undefined) {
            throw new runtime.RequiredError('createTwoWayStreamRequest','Required parameter requestParameters.createTwoWayStreamRequest was null or undefined when calling liveStreamApiControllerCreateTwoWayStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:create-two-way-stream`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTwoWayStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerCreateTwoWayStream(requestParameters: LiveStreamApiControllerCreateTwoWayStreamRequest): Promise<void> {
        await this.liveStreamApiControllerCreateTwoWayStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerDeleteCommentRaw(requestParameters: LiveStreamApiControllerDeleteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerDeleteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling liveStreamApiControllerDeleteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments/{commentId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerDeleteComment(requestParameters: LiveStreamApiControllerDeleteCommentRequest): Promise<void> {
        await this.liveStreamApiControllerDeleteCommentRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerDisconnectWalletRaw(requestParameters: LiveStreamApiControllerDisconnectWalletRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerDisconnectWallet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:disconnectWallet`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerDisconnectWallet(requestParameters: LiveStreamApiControllerDisconnectWalletRequest): Promise<void> {
        await this.liveStreamApiControllerDisconnectWalletRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerEditLiveStreamRaw(requestParameters: LiveStreamApiControllerEditLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerEditLiveStream.');
        }

        if (requestParameters.editLiveStreamRequest === null || requestParameters.editLiveStreamRequest === undefined) {
            throw new runtime.RequiredError('editLiveStreamRequest','Required parameter requestParameters.editLiveStreamRequest was null or undefined when calling liveStreamApiControllerEditLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:edit`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editLiveStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerEditLiveStream(requestParameters: LiveStreamApiControllerEditLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerEditLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerEndTwoWayStreamRaw(requestParameters: LiveStreamApiControllerEndTwoWayStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerEndTwoWayStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:end-two-way-stream`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerEndTwoWayStream(requestParameters: LiveStreamApiControllerEndTwoWayStreamRequest): Promise<void> {
        await this.liveStreamApiControllerEndTwoWayStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerFinishLiveStreamRaw(requestParameters: LiveStreamApiControllerFinishLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerFinishLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:finish`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerFinishLiveStream(requestParameters: LiveStreamApiControllerFinishLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerFinishLiveStreamRaw(requestParameters);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGenerateTokensRaw(requestParameters: LiveStreamApiControllerGenerateTokensRequest): Promise<runtime.ApiResponse<TokensResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGenerateTokens.');
        }

        if (requestParameters.generateTokenRequest === null || requestParameters.generateTokenRequest === undefined) {
            throw new runtime.RequiredError('generateTokenRequest','Required parameter requestParameters.generateTokenRequest was null or undefined when calling liveStreamApiControllerGenerateTokens.');
        }

        const queryParameters: any = {};

        if (requestParameters.gatedShowPassword !== undefined) {
            queryParameters['gatedShowPassword'] = requestParameters.gatedShowPassword;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:generateTokens`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generateTokenRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGenerateTokens(requestParameters: LiveStreamApiControllerGenerateTokensRequest): Promise<TokensResponse> {
        const response = await this.liveStreamApiControllerGenerateTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetCommentUpvotersRaw(requestParameters: LiveStreamApiControllerGetCommentUpvotersRequest): Promise<runtime.ApiResponse<CommentUpvotersResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetCommentUpvoters.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling liveStreamApiControllerGetCommentUpvoters.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling liveStreamApiControllerGetCommentUpvoters.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments/{commentId}/upvoters`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetCommentUpvoters(requestParameters: LiveStreamApiControllerGetCommentUpvotersRequest): Promise<CommentUpvotersResponse> {
        const response = await this.liveStreamApiControllerGetCommentUpvotersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetCommentUpvotesRaw(requestParameters: LiveStreamApiControllerGetCommentUpvotesRequest): Promise<runtime.ApiResponse<Array<CommentUpvoteItem>>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetCommentUpvotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.sinceMinutesAgo !== undefined) {
            queryParameters['sinceMinutesAgo'] = requestParameters.sinceMinutesAgo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comment-upvotes`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetCommentUpvotes(requestParameters: LiveStreamApiControllerGetCommentUpvotesRequest): Promise<Array<CommentUpvoteItem>> {
        const response = await this.liveStreamApiControllerGetCommentUpvotesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerGetGatedShowPasswordRaw(requestParameters: LiveStreamApiControllerGetGatedShowPasswordRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetGatedShowPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:getGatedShowPassword`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async liveStreamApiControllerGetGatedShowPassword(requestParameters: LiveStreamApiControllerGetGatedShowPasswordRequest): Promise<string> {
        const response = await this.liveStreamApiControllerGetGatedShowPasswordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetMostUpvotedCommentRaw(requestParameters: LiveStreamApiControllerGetMostUpvotedCommentRequest): Promise<runtime.ApiResponse<MostUpvotedCommentResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetMostUpvotedComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments:getMostUpvoted`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetMostUpvotedComment(requestParameters: LiveStreamApiControllerGetMostUpvotedCommentRequest): Promise<MostUpvotedCommentResponse> {
        const response = await this.liveStreamApiControllerGetMostUpvotedCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetMostUpvotedCommentV2Raw(requestParameters: LiveStreamApiControllerGetMostUpvotedCommentV2Request): Promise<runtime.ApiResponse<MostUpvotedCommentResponseWrapper>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetMostUpvotedCommentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/live-streams/{liveStreamId}/comments:getMostUpvoted`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerGetMostUpvotedCommentV2(requestParameters: LiveStreamApiControllerGetMostUpvotedCommentV2Request): Promise<MostUpvotedCommentResponseWrapper> {
        const response = await this.liveStreamApiControllerGetMostUpvotedCommentV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerGetNftAvatarRaw(requestParameters: LiveStreamApiControllerGetNftAvatarRequest): Promise<runtime.ApiResponse<GetNftAvatarResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetNftAvatar.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:getAvatar`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerGetNftAvatar(requestParameters: LiveStreamApiControllerGetNftAvatarRequest): Promise<GetNftAvatarResponse> {
        const response = await this.liveStreamApiControllerGetNftAvatarRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerGetNftsRaw(requestParameters: LiveStreamApiControllerGetNftsRequest): Promise<runtime.ApiResponse<GetLiveStreamNftsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetNfts.');
        }

        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling liveStreamApiControllerGetNfts.');
        }

        if (requestParameters.signature === null || requestParameters.signature === undefined) {
            throw new runtime.RequiredError('signature','Required parameter requestParameters.signature was null or undefined when calling liveStreamApiControllerGetNfts.');
        }

        if (requestParameters.expiredAt === null || requestParameters.expiredAt === undefined) {
            throw new runtime.RequiredError('expiredAt','Required parameter requestParameters.expiredAt was null or undefined when calling liveStreamApiControllerGetNfts.');
        }

        const queryParameters: any = {};

        if (requestParameters.address !== undefined) {
            queryParameters['address'] = requestParameters.address;
        }

        if (requestParameters.signature !== undefined) {
            queryParameters['signature'] = requestParameters.signature;
        }

        if (requestParameters.expiredAt !== undefined) {
            queryParameters['expiredAt'] = requestParameters.expiredAt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:getEligibleNfts`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerGetNfts(requestParameters: LiveStreamApiControllerGetNftsRequest): Promise<GetLiveStreamNftsResponse> {
        const response = await this.liveStreamApiControllerGetNftsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerGetRecordingURLsRaw(requestParameters: LiveStreamApiControllerGetRecordingURLsRequest): Promise<runtime.ApiResponse<GetRecordingURLsResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerGetRecordingURLs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:getRecordingURLs`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerGetRecordingURLs(requestParameters: LiveStreamApiControllerGetRecordingURLsRequest): Promise<GetRecordingURLsResponse> {
        const response = await this.liveStreamApiControllerGetRecordingURLsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerJoinRaw(requestParameters: LiveStreamApiControllerJoinRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerJoin.');
        }

        const queryParameters: any = {};

        if (requestParameters.gatedShowPassword !== undefined) {
            queryParameters['gatedShowPassword'] = requestParameters.gatedShowPassword;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:join`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.joinRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerJoin(requestParameters: LiveStreamApiControllerJoinRequest): Promise<void> {
        await this.liveStreamApiControllerJoinRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerModerateLiveStreamRaw(requestParameters: LiveStreamApiControllerModerateLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerModerateLiveStream.');
        }

        if (requestParameters.moderateLiveStreamRequest === null || requestParameters.moderateLiveStreamRequest === undefined) {
            throw new runtime.RequiredError('moderateLiveStreamRequest','Required parameter requestParameters.moderateLiveStreamRequest was null or undefined when calling liveStreamApiControllerModerateLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:moderate`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderateLiveStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerModerateLiveStream(requestParameters: LiveStreamApiControllerModerateLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerModerateLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerPatchLiveStreamRaw(requestParameters: LiveStreamApiControllerPatchLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerPatchLiveStream.');
        }

        if (requestParameters.patchLiveStreamRequest === null || requestParameters.patchLiveStreamRequest === undefined) {
            throw new runtime.RequiredError('patchLiveStreamRequest','Required parameter requestParameters.patchLiveStreamRequest was null or undefined when calling liveStreamApiControllerPatchLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchLiveStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerPatchLiveStream(requestParameters: LiveStreamApiControllerPatchLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerPatchLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerPauseLiveStreamRaw(requestParameters: LiveStreamApiControllerPauseLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerPauseLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:pause`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pauseRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerPauseLiveStream(requestParameters: LiveStreamApiControllerPauseLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerPauseLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerPreviewWrapUpEmailRaw(requestParameters: LiveStreamApiControllerPreviewWrapUpEmailRequest): Promise<runtime.ApiResponse<PreviewLiveStreamWrapEmailResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerPreviewWrapUpEmail.');
        }

        if (requestParameters.previewLiveStreamWrapEmailRequest === null || requestParameters.previewLiveStreamWrapEmailRequest === undefined) {
            throw new runtime.RequiredError('previewLiveStreamWrapEmailRequest','Required parameter requestParameters.previewLiveStreamWrapEmailRequest was null or undefined when calling liveStreamApiControllerPreviewWrapUpEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:preview-wrap-up-email`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewLiveStreamWrapEmailRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerPreviewWrapUpEmail(requestParameters: LiveStreamApiControllerPreviewWrapUpEmailRequest): Promise<PreviewLiveStreamWrapEmailResponse> {
        const response = await this.liveStreamApiControllerPreviewWrapUpEmailRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamApiControllerRemoveTipRaw(requestParameters: LiveStreamApiControllerRemoveTipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerRemoveTip.');
        }

        if (requestParameters.tipId === null || requestParameters.tipId === undefined) {
            throw new runtime.RequiredError('tipId','Required parameter requestParameters.tipId was null or undefined when calling liveStreamApiControllerRemoveTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/tips/{tipId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"tipId"}}`, encodeURIComponent(String(requestParameters.tipId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerRemoveTip(requestParameters: LiveStreamApiControllerRemoveTipRequest): Promise<void> {
        await this.liveStreamApiControllerRemoveTipRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerRemoveUserFromLiveStreamCommentDenylistRaw(requestParameters: LiveStreamApiControllerRemoveUserFromLiveStreamCommentDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerRemoveUserFromLiveStreamCommentDenylist.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling liveStreamApiControllerRemoveUserFromLiveStreamCommentDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/blocked/{userId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerRemoveUserFromLiveStreamCommentDenylist(requestParameters: LiveStreamApiControllerRemoveUserFromLiveStreamCommentDenylistRequest): Promise<void> {
        await this.liveStreamApiControllerRemoveUserFromLiveStreamCommentDenylistRaw(requestParameters);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerReplayLiveStreamHeartBeatRaw(requestParameters: LiveStreamApiControllerReplayLiveStreamHeartBeatRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerReplayLiveStreamHeartBeat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/replay-live-streams/{liveStreamId}:ping`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public API
     */
    async liveStreamApiControllerReplayLiveStreamHeartBeat(requestParameters: LiveStreamApiControllerReplayLiveStreamHeartBeatRequest): Promise<void> {
        await this.liveStreamApiControllerReplayLiveStreamHeartBeatRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerReportLiveStreamRaw(requestParameters: LiveStreamApiControllerReportLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerReportLiveStream.');
        }

        if (requestParameters.reportLiveStreamRequest === null || requestParameters.reportLiveStreamRequest === undefined) {
            throw new runtime.RequiredError('reportLiveStreamRequest','Required parameter requestParameters.reportLiveStreamRequest was null or undefined when calling liveStreamApiControllerReportLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:report`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.reportLiveStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerReportLiveStream(requestParameters: LiveStreamApiControllerReportLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerReportLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerResumeLiveStreamRaw(requestParameters: LiveStreamApiControllerResumeLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerResumeLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:resume`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.resumeLiveStreamRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerResumeLiveStream(requestParameters: LiveStreamApiControllerResumeLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerResumeLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerSendCommentRaw(requestParameters: LiveStreamApiControllerSendCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerSendComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling liveStreamApiControllerSendComment.');
        }

        if (requestParameters.sendCommentRequest === null || requestParameters.sendCommentRequest === undefined) {
            throw new runtime.RequiredError('sendCommentRequest','Required parameter requestParameters.sendCommentRequest was null or undefined when calling liveStreamApiControllerSendComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments/{commentId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerSendComment(requestParameters: LiveStreamApiControllerSendCommentRequest): Promise<void> {
        await this.liveStreamApiControllerSendCommentRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerSendNotificationToWaitlistRaw(requestParameters: LiveStreamApiControllerSendNotificationToWaitlistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerSendNotificationToWaitlist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:send-notification-to-waitlist`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerSendNotificationToWaitlist(requestParameters: LiveStreamApiControllerSendNotificationToWaitlistRequest): Promise<void> {
        await this.liveStreamApiControllerSendNotificationToWaitlistRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerSendWrapUpEmailRaw(requestParameters: LiveStreamApiControllerSendWrapUpEmailRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerSendWrapUpEmail.');
        }

        if (requestParameters.sendWrapUpEmailRequest === null || requestParameters.sendWrapUpEmailRequest === undefined) {
            throw new runtime.RequiredError('sendWrapUpEmailRequest','Required parameter requestParameters.sendWrapUpEmailRequest was null or undefined when calling liveStreamApiControllerSendWrapUpEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:send-wrap-up-email`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendWrapUpEmailRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerSendWrapUpEmail(requestParameters: LiveStreamApiControllerSendWrapUpEmailRequest): Promise<void> {
        await this.liveStreamApiControllerSendWrapUpEmailRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerStartLiveStreamRaw(requestParameters: LiveStreamApiControllerStartLiveStreamRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerStartLiveStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:start`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerStartLiveStream(requestParameters: LiveStreamApiControllerStartLiveStreamRequest): Promise<void> {
        await this.liveStreamApiControllerStartLiveStreamRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerStartWatchingRaw(requestParameters: LiveStreamApiControllerStartWatchingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerStartWatching.');
        }

        if (requestParameters.startWatchRequest === null || requestParameters.startWatchRequest === undefined) {
            throw new runtime.RequiredError('startWatchRequest','Required parameter requestParameters.startWatchRequest was null or undefined when calling liveStreamApiControllerStartWatching.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:startWatching`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.startWatchRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerStartWatching(requestParameters: LiveStreamApiControllerStartWatchingRequest): Promise<void> {
        await this.liveStreamApiControllerStartWatchingRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerStopWatchingRaw(requestParameters: LiveStreamApiControllerStopWatchingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerStopWatching.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:stopWatching`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerStopWatching(requestParameters: LiveStreamApiControllerStopWatchingRequest): Promise<void> {
        await this.liveStreamApiControllerStopWatchingRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerSwitchShowEventRaw(requestParameters: LiveStreamApiControllerSwitchShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerSwitchShowEvent.');
        }

        if (requestParameters.switchShowEventRequest === null || requestParameters.switchShowEventRequest === undefined) {
            throw new runtime.RequiredError('switchShowEventRequest','Required parameter requestParameters.switchShowEventRequest was null or undefined when calling liveStreamApiControllerSwitchShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:switch-show-event`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.switchShowEventRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerSwitchShowEvent(requestParameters: LiveStreamApiControllerSwitchShowEventRequest): Promise<void> {
        await this.liveStreamApiControllerSwitchShowEventRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerSwitchUpcomingShowRaw(requestParameters: LiveStreamApiControllerSwitchUpcomingShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerSwitchUpcomingShow.');
        }

        if (requestParameters.switchUpcomingShowRequest === null || requestParameters.switchUpcomingShowRequest === undefined) {
            throw new runtime.RequiredError('switchUpcomingShowRequest','Required parameter requestParameters.switchUpcomingShowRequest was null or undefined when calling liveStreamApiControllerSwitchUpcomingShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:switch-upcoming-show`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.switchUpcomingShowRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerSwitchUpcomingShow(requestParameters: LiveStreamApiControllerSwitchUpcomingShowRequest): Promise<void> {
        await this.liveStreamApiControllerSwitchUpcomingShowRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerUpdateTipRaw(requestParameters: LiveStreamApiControllerUpdateTipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerUpdateTip.');
        }

        if (requestParameters.tipId === null || requestParameters.tipId === undefined) {
            throw new runtime.RequiredError('tipId','Required parameter requestParameters.tipId was null or undefined when calling liveStreamApiControllerUpdateTip.');
        }

        if (requestParameters.updateTipRequest === null || requestParameters.updateTipRequest === undefined) {
            throw new runtime.RequiredError('updateTipRequest','Required parameter requestParameters.updateTipRequest was null or undefined when calling liveStreamApiControllerUpdateTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/tips/{tipId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"tipId"}}`, encodeURIComponent(String(requestParameters.tipId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateTipRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerUpdateTip(requestParameters: LiveStreamApiControllerUpdateTipRequest): Promise<void> {
        await this.liveStreamApiControllerUpdateTipRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerUpvoteCommentRaw(requestParameters: LiveStreamApiControllerUpvoteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerUpvoteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling liveStreamApiControllerUpvoteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/comments/{commentId}:upvote`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerUpvoteComment(requestParameters: LiveStreamApiControllerUpvoteCommentRequest): Promise<void> {
        await this.liveStreamApiControllerUpvoteCommentRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerWaveFollowersToWatchRaw(requestParameters: LiveStreamApiControllerWaveFollowersToWatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerWaveFollowersToWatch.');
        }

        if (requestParameters.waveFollowersToWatchRequest === null || requestParameters.waveFollowersToWatchRequest === undefined) {
            throw new runtime.RequiredError('waveFollowersToWatchRequest','Required parameter requestParameters.waveFollowersToWatchRequest was null or undefined when calling liveStreamApiControllerWaveFollowersToWatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:waveFollowers`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.waveFollowersToWatchRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerWaveFollowersToWatch(requestParameters: LiveStreamApiControllerWaveFollowersToWatchRequest): Promise<void> {
        await this.liveStreamApiControllerWaveFollowersToWatchRaw(requestParameters);
    }

    /**
     */
    async liveStreamApiControllerWavedToUserEnterRaw(requestParameters: LiveStreamApiControllerWavedToUserEnterRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamApiControllerWavedToUserEnter.');
        }

        if (requestParameters.wavedToUserEnterRequest === null || requestParameters.wavedToUserEnterRequest === undefined) {
            throw new runtime.RequiredError('wavedToUserEnterRequest','Required parameter requestParameters.wavedToUserEnterRequest was null or undefined when calling liveStreamApiControllerWavedToUserEnter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:wavedToUserEnter`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.wavedToUserEnterRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamApiControllerWavedToUserEnter(requestParameters: LiveStreamApiControllerWavedToUserEnterRequest): Promise<void> {
        await this.liveStreamApiControllerWavedToUserEnterRaw(requestParameters);
    }

}
